import XCircle from '@components/Icons/XCircle';
import Buttons from '@components/Buttons';
import InputComposer from '@components/InputComposer';
import { AnimatePresence, m } from 'framer-motion';
import { useFeatureFlag } from '@providers/FeatureFlags';
import classes from './UserWorkflowConversation.module.scss';

type Props = {
  conversationOpenStepId: string | null;
  isMobile: boolean;
  onClose: () => void;
};

const UserWorkflowConversation: React.FC<Props> = ({ conversationOpenStepId, isMobile, onClose }) => {
  const workflowConversationFeatureFlag = useFeatureFlag('workflow-conversation');
  if (!workflowConversationFeatureFlag) {
    return null;
  }
  return (
    <AnimatePresence>
      {conversationOpenStepId && (
        <m.div
          initial={{ opacity: 0, y: isMobile ? 200 : 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{
            opacity: 0,
            y: isMobile ? 200 : 10,
          }}
          className={isMobile ? classes.conversationMobile : classes.conversation}
        >
          <div className={classes.conversation_header}>
            <Buttons isWrapper onClick={onClose}>
              <XCircle size={24} weight="fill" />
            </Buttons>
            Conversation {conversationOpenStepId}
            <div />
          </div>
          <div className={classes.conversation_messages}>
            <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
            enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
            in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident,
            sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
            <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
            enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
            in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident,
            sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
            <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
            enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
            in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident,
            sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
            <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
            enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
            in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident,
            sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
          </div>
          <div className={classes.conversation_input}>
            <InputComposer placeholder="Type a message" isFetching={false} referenceId="test" referenceType="test" />
          </div>
        </m.div>
      )}
    </AnimatePresence>
  );
};

export default UserWorkflowConversation;
